import createSvgIcon from '@mui/material/utils/createSvgIcon';

export const CheckCircleAltIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.375 11.9103C7.97482 13.0863 9.23907 15.2732 10.0918 17.1964C11.5173 14.0777 14.0293 9.87805 17.625 6.75C14.5057 8.81045 11.9226 11.5928 10.0918 14.864C9.25426 13.4546 7.9317 12.4036 6.375 11.9103Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>,
  'CheckCircleAlt',
);

export function CheckCircleAltSvg() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.375 11.9103C7.97482 13.0863 9.23907 15.2732 10.0918 17.1964C11.5173 14.0777 14.0293 9.87805 17.625 6.75C14.5057 8.81045 11.9226 11.5928 10.0918 14.864C9.25426 13.4546 7.9317 12.4036 6.375 11.9103Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
}
